<template>
  <div class="page--home">
    <GTopAds key="GTopAds-Home" />

    <div class="container">
      <div class="row product-row">
        <div class="col-universal">
          <div class="content-page transparent">
            <template v-if="!isLoadingFinish.blockBannerHome || blockBannerHome.length">
              <BlockBannerHome
                key="blockBannerHome"
                class-modifier="trending--products"
                :products="blockBannerHome"
                :is-loading-finish="isLoadingFinish.blockBannerHome"
              />
            </template>
            <div v-if="isDesktop" class="thight-box"></div>
            <ExpertReviews />
            <div class="thight-box"></div>
            <div
              v-if="!isLoadingFinish.trendingProducts || (isLoadingFinish.trendingProducts && showTrendingProducts)"
              class="trending trending-review section"
            >
              <div v-if="isLoadingFinish.trendingProducts" class="header-section you-might-love-these">
                <h3 class="section-heading">{{ ourCuratedSelectionsTitle }}</h3>
                <a href="" class="show-all" @click.prevent="toproductMatch">
                  See all
                  <img
                    v-if="isDesktop"
                    src="/assets/img/arrow_carrot-right.svg"
                    alt="icon-next"
                    loading="lazy"
                    width="6"
                    height="9"
                    :style="`margin-left: 8px;`"
                  />
                </a>
              </div>
              <ListProductSlide
                key="trendingProducts"
                class-modifier="trending--products"
                :products="isDesktop ? trendingProducts : trendingProductsMobile"
                :is-loading-finish="isLoadingFinish.trendingProducts"
                object_type="trending_products"
                section="trending_products"
                :per-page-custom-props="isDesktop ? 6 : 3"
                @get-products-trending="checkSkipTrending()"
              />
            </div>
            <div class="thight-box"></div>
            <RecentlyBought />
            <div class="thight-box"></div>
            <Intersect @enter="enterSection('TryThisProducts')">
              <div class="lazy-pixel">
                <div v-if="section.TryThisProducts">
                  <div
                    v-if="!isLoadingFinish.tryThisProducts || (isLoadingFinish.tryThisProducts && showTryThisProducts)"
                    class="trending trending-review section"
                  >
                    <div v-if="isLoadingFinish.tryThisProducts" class="header-section">
                      <img
                        src="/assets/img/icon-trending.svg"
                        alt="Trending in soco icon"
                        width="20"
                        height="20"
                        class="icon-header"
                      />
                      <h3 class="section-heading">{{ trendingInSocoTitle }}</h3>
                    </div>
                    <div class="lazy-pixel">
                      <ListProductSlide
                        key="tryThisProducts"
                        class-modifier="trending--have-you-try"
                        :products="isDesktop ? $store.state.product.tryProducts : tryThisProductsMobile"
                        :is-loading-finish="isLoadingFinish.tryThisProducts"
                        object_type="have_you_tried_this"
                        section="have_you_tried_this"
                        @get-products-try="checkSkipTry()"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Intersect>
            <div class="thight-box"></div>

            <Intersect @enter="enterSection('ProductMatch')">
              <div class="lazy-pixel">
                <ProductMatch v-if="section.ProductMatch" />
              </div>
            </Intersect>

            <div class="thight-box"></div>
            <!-- <Intersect @enter="enterSection('MostReviewBrand')">
              <div class="lazy-pixel">
                <MostReviewBrand v-if="section.MostReviewBrand" key="MostReviewBrand" class="section" />
              </div>
            </Intersect> -->
          </div>
          <Intersect @enter="enterSection('RecentReviews')">
            <div class="content-page content-page--recent-reviews">
              <RecentReviews v-if="section.RecentReviews" key="RecentReviews" />
            </div>
          </Intersect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Auth from '@/shared/auth';
const Config = require('~/config/default.env').default;

export default {
  name: 'my-home',
  components: {
    ListProductSlide: () => import('./snippet/list-product-slide'),
    RecentReviews: () => import('./snippet/recent-reviews'),
    BlockBannerHome: () => import('./snippet/block-banner-home'),
    ProductMatch: () => import('./snippet/product-match'),
    ExpertReviews: () => import('./snippet/expert-review'),
    RecentlyBought: () => import('./snippet/recently-bought'),
    // MostReviewBrand: () => import('./snippet/most-review-brand'),
  },
  data() {
    return {
      isLoadingFinish: {
        recommendedProducts: false,
        trendingProducts: false,
        blockBannerHome: false,
        tryThisProducts: false,
      },
      trendingProductsMobile: [],
      blockBannerHome: [],
      tryThisProductsMobile: [],
      recommendedProducts: [],
      skipTrending: 0,
      limitTrending: 10,
      skipTry: 0,
      limitTry: 10,
      mobileSubCat: 0,
      isRendered: false,
      section: {
        RecentReviews: false,
        Horoscope: false,
        BeTheFirstReview: false,
        topReviewer: false,
        MostReviewBrand: false,
        TabPopularReviews: false,
        ListPopularReview: false,
        ProductMatch: false,
        ListProductSlide: false,
        PopularCategory: false,
        EditorReview: false,
        TryThisProducts: false,
      },
      ourCuratedSelectionsTitle: 'Our Curated Selections',
      trendingInSocoTitle: 'Trending in SOCO',
      isLoadingTrendingProducts: false,
    };
  },
  computed: {
    ...mapState('$_Header', ['showOverlay']),
    ...mapGetters('categories', ['getPopularTitle']),
    ...mapGetters('products/popular-category', ['hasPopularCategory']),

    popularCategory() {
      return this.$store.state.products['popular-category'];
    },

    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    popularReviewMobile() {
      if (this.mobileSubCat !== null) {
        return this.popularCategory[this.mobileSubCat];
      } else {
        return [];
      }
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isProductMatchEnteredLoggedIn() {
      return this.section.ProductMatch && this.isLogin ? true : false;
    },
    trendingProducts() {
      return (this.$store.state.product && this.$store.state.product.trendingProducts) || [];
    },
    showTrendingProducts() {
      return this.isDesktop ? Boolean(this.trendingProducts.length) : Boolean(this.trendingProductsMobile.length);
    },
    tryThisProducts() {
      return this.$store.state.product && this.$store.state.product.tryProducts;
    },
    showTryThisProducts() {
      return this.isDesktop ? Boolean(this.tryThisProducts.length) : Boolean(this.tryThisProductsMobile.length);
    },
  },
  watch: {
    isProductMatchEnteredLoggedIn(newVal) {
      if (newVal) {
        // this.getRecommendedProducts();
      }
    },
    isLogin: {
      handler(newVal) {
        this.$store.commit('product_trending', { data: [] });
        if (this.$store.state.product.trendingProducts.length === 0) {
          if (this.isDesktop) {
            this.getTrendingProducts();
          } else {
            this.getTrendingProductsMobile();
          }
        }
      },
      immediate: true,
    },
    'section.TabPopularReviews'(newVal) {
      if (newVal) {
        this.getPopularCategory();
      }
    },
    'section.ListPopularReview'(newVal) {
      if (newVal) {
        this.getPopularCategory();
      }
    },
  },
  created() {
    if (this.$store.state.modal.isModalShow.shareExperience) {
      this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
    }
    this.getBlockBannerHome();
    if (this.$store.state.screen.isDesktop) {
      //call on first time
      this.$store.commit('product_try', { data: [] });
      this.section.TryThisProducts = true;
      this.getTryThisProducts();
    } else {
      this.getTryThisProductsMobile();
      this.section.TryThisProducts = true;
    }

    setTimeout(() => {
      this.isRendered = true;
    }, 500);
  },

  mounted() {
    if (this.isLogin) {
      // this.getRecommendedProducts();
    }
  },
  methods: {
    ...mapActions('categories', ['getCategories']),
    ...mapActions('products/popular-category', ['getPopularCategory']),

    enterSection(field) {
      if (this.isRendered) {
        if (field == 'TryThisProducts' && !this.section.TryThisProducts) {
          if (this.$store.state.screen.isDesktop) {
            this.getTryThisProducts();
          } else {
            this.getTryThisProductsMobile();
          }
        }

        this.section[field] = true;
      }
    },
    toproductMatch() {
      if (this.isLogin) {
        if (Boolean(this.user.beauty && this.user.beauty.length)) {
          this.$router.push({ name: 'OurCuratedSelections' });
        } else {
          this.$store.commit('toggleModalGlobalState', {
            modalName: 'confirmBP',
          });
        }
      } else {
        this.$router.push({ name: 'OurCuratedSelections' });
      }
    },
    getBlockBannerHome() {
      this.isLoadingFinish.blockBannerHome = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/banners`, {
          params: {
            filter: {
              status: 'active',
              // is_deleted: false,
              location: 'expert-choice-banner',
            },
            sort: 'order',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            this.blockBannerHome = response.data.data;
          } else {
            this.blockBannerHome = [];
          }

          if (this.blockBannerHome.length <= 0) {
            this.section.ProductMatch = true;
          }

          this.isLoadingFinish.blockBannerHome = true;
        })
        .catch((err) => {
          this.blockBannerHome = [];
          this.isLoadingFinish.blockBannerHome = true;
        });
    },
    checkSkipTrending() {
      if (this.isLoadingTrendingProducts) {
        return;
      }
      this.skipTrending = this.skipTrending + this.$store.state.product.trendingProducts.length;
      if (this.$store.state.product.trendingProducts.length < 10) {
        this.getTrendingProducts();
      } else {
        return;
      }
    },
    checkSkipTry() {
      this.skipTry = this.skipTry + this.$store.state.product.tryProducts.length;
      if (this.$store.state.product.tryProducts.length < 10) {
        this.getTryThisProducts();
      } else {
        return;
      }
    },
    getTrendingProducts() {
      if (this.isLoadingTrendingProducts) {
        return;
      }
      this.isLoadingTrendingProducts = true;

      if (this.skipTrending > 0) {
        this.isLoadingFinish.trendingProducts = true;
      } else {
        this.isLoadingFinish.trendingProducts = false;
      }
      Promise.all([
        this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/trending`, {
          params: {
            filter: {
              is_reviewed: true,
              is_verified_purchase: true,
            },
            section: 'TrendingProducts',
            skip: this.skipTrending,
            limit: this.limitTrending,
          },
          withCredentials: true,
        }),
        this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/trending/title'),
      ])
        .then(([response, titleResponse]) => {
          this.isLoadingTrendingProducts = false;

          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items.map((res) => {
              if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                res.default_combination.is_wishlist = false;
              }
              return res;
            });
            if (this.$store.state.product.trendingProducts && this.$store.state.product.trendingProducts.length) {
              this.$store.commit('product_trending', { data: items, merge: true });
            } else {
              this.$store.commit('product_trending', { data: items });
            }
          } else {
            this.$store.commit('product_trending', { data: [] });
          }
          if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
            this.ourCuratedSelectionsTitle = titleResponse.data.data;
          }
          this.isLoadingFinish.trendingProducts = true;
        })
        .catch((err) => {
          this.isLoadingTrendingProducts = false;

          this.$store.commit('product_trending', { data: [] });
          this.isLoadingFinish.trendingProducts = true;
        });
    },
    getTrendingProductsMobile() {
      this.isLoadingFinish.trendingProducts = false;
      Promise.all([
        this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/trending`, {
          params: {
            filter: {
              is_reviewed: true,
              is_verified_purchase: true,
            },
            section: 'TrendingProducts',
          },
          withCredentials: true,
        }),
        this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/trending/title'),
      ])
        .then(([response, titleResponse]) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items.map((res) => {
              if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                res.default_combination.is_wishlist = false;
              }
              return res;
            });
            this.trendingProductsMobile = items || [];
          } else {
            this.trendingProductsMobile = [];
          }
          if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
            this.ourCuratedSelectionsTitle = titleResponse.data.data;
          }
          this.isLoadingFinish.trendingProducts = true;
        })
        .catch((err) => {
          this.trendingProductsMobile = [];
          this.isLoadingFinish.trendingProducts = true;
        });
    },
    getRecommendedProducts() {
      this.isLoadingFinish.recommendedProducts = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/sociolla/recommendation`, {
          params: {
            filter: {
              is_reviewed: true,
              is_active_in_review: true,
              is_active: true,
            },
            limit: 10,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.recommendedProducts = response.data.data;
          } else {
            this.recommendedProducts = [];
          }
          this.isLoadingFinish.recommendedProducts = true;
        })
        .catch((err) => {
          this.isLoadingFinish.recommendedProducts = true;
          this.recommendedProducts = [];
        });
    },
    getTryThisProducts() {
      if (this.skipTry > 0) {
        this.isLoadingFinish.tryThisProducts = true;
      } else {
        this.isLoadingFinish.tryThisProducts = false;
      }
      Promise.all([
        this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/have-you-tried`, {
          params: {
            skip: this.skipTry,
            limit: this.limitTry,
            section: 'haveYouTriedProducts',
            fields:
              'active brand default_category discount_type id images la_ps_product_id_product max_price min_price name has_bookmarked price price_after_discount review_stats total_reviews parent_category is_reviewed',
          },
        }),
        this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/have-you-tried/title'),
      ])
        .then(([response, titleResponse]) => {
          if (response.status === 200 && response.data.data) {
            // this.tryThisProducts = response.data.data;
            const response_data = response.data.data;
            if (this.$store.state.product.tryProducts && this.$store.state.product.tryProducts.length) {
              this.$store.commit('product_try', { data: response_data, merge: true });
            } else {
              this.$store.commit('product_try', { data: response_data });
            }
          } else {
            this.tryThisProducts = [];
            this.$store.commit('product_try', { data: [] });
          }
          if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
            this.trendingInSocoTitle = titleResponse.data.data;
          }
          this.isLoadingFinish.tryThisProducts = true;
        })
        .catch((err) => {
          this.isLoadingFinish.tryThisProducts = true;
          // this.tryThisProducts = [];
          this.$store.commit('product_try', { data: [] });
        });
    },
    getTryThisProductsMobile() {
      this.isLoadingFinish.tryThisProducts = false;
      Promise.all([
        this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/have-you-tried`, {
          params: {
            filter: {
              is_reviewed: true,
            },
            section: 'haveYouTriedProducts',
            fields:
              'active brand default_category discount_type id images la_ps_product_id_product max_price min_price name has_bookmarked price price_after_discount review_stats total_reviews parent_category is_reviewed',
          },
        }),
        this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/have-you-tried/title'),
      ])
        .then(([response, titleResponse]) => {
          if (response.status === 200 && response.data.data) {
            this.tryThisProductsMobile = response.data.data;
          } else {
            this.tryThisProductsMobile = [];
          }
          if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
            this.trendingInSocoTitle = titleResponse.data.data;
          }
          this.isLoadingFinish.tryThisProducts = true;
        })
        .catch((err) => {
          this.isLoadingFinish.tryThisProducts = true;
          this.tryThisProductsMobile = [];
        });
    },
    changepopularReviewMobile(subCat) {
      this.mobileSubCat = subCat;
    },
    openLoginOtf() {
      Auth.CentralAuth.login();
    },
    selectProduct(product) {
      const notInReviewPage = !/review[/]add/.test(this.$route.path);
      if (notInReviewPage) {
        this.$router.push(`/review/add/${product['id']}`);
      }
      this.$store.dispatch('setDataSelectedProduct', {
        dataSelectedProduct: product,
        component: this,
      });
    },
    saveSearchHistoryClicks(entity_id, entity_type) {
      if (!this.isLogin) {
        return;
      }
      const params = {
        entity_id: entity_id, // id product
        keyword: '',
        entity_type: entity_type,
      };
      return axios.post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params);
    },
  },
};
</script>

<style lang="scss" scoped>
.trending-review {
  background-color: #ffffff;
  margin-top: 0;
  padding: 16px 24px;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  .section-card-slider {
    margin-bottom: 0;
  }
  @media (max-width: 991px) {
    padding: 16px 0px 16px 16px;
    box-shadow: none;
  }
  .you-might-love-these {
    justify-content: space-between;
  }
  &::v-deep .list-scrollable {
    padding: 0;
  }
}
.VueCarousel-inner /deep/ {
  gap: 24px !important;
}
</style>
